import {
  useState, useEffect,
} from 'react';
// import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import telemetryActions from '@state/telemetry/actions';
// import { useTranslation } from 'react-i18next';
import devicesApi from '@api/devicesApi';
import telemetryApi from '@api/telemetryApi';

const granularity = [
  { name: 'Detalle', value: 'minute' },
  { name: 'Hour', value: 'hour' },
  // { name: 'Day', value: 'day' },
  // { name: 'Month', value: 'month' },
  { name: 'Month', value: 'day' },
  // { name: 'Year', value: 'year' },
  { name: 'Year', value: 'month' },
];

function useConsultGraph() {

  // const dispatch = useDispatch();

  const { device } = useParams();
  const [infoDevice, setInfoDevice] = useState(null);

  const [deviceAllInfo, setDeviceAllInfo] = useState({});
  const [deviceType, setDeviceType] = useState({});
  const [defaultGranularity, setDefaultGranularity] = useState(granularity[0].value);
  const [deviceField, setDeviceField] = useState(null);
  const [variableField, setVariableField] = useState([]);
  const [optionVariableField, setOptionVariableField] = useState([]);

  const dateFormat = 'YYYY-MM-DD';

  // const { t } = useTranslation();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [modePicker, setModePicker] = useState('');
  const [modePickerFormat, setModePickerFormat] = useState('YYYY-MM-DD');
  // const [modePickerLabel, setModePickerLabel] = useState('Day');
  const [datePicker, setDatePicker] = useState(moment(new Date(), 'YYYY/MM/DD'));

  const [seriesGraph, setSeriesGraph] = useState([]);
  const [categoriesGraph, setCategoriesGraph] = useState([]);

  const changeDate = (e) => {

    if (modePickerFormat === 'YYYY-MM-DD') {

      setDatePicker(moment(datePicker, dateFormat).add(e, 'days'));

    } else if (modePickerFormat === 'YYYY-MM') {

      setDatePicker(moment(datePicker, dateFormat).add(e, 'months'));

    } else {

      setDatePicker(moment(datePicker, dateFormat).add(e, 'years'));

    }

  };

  const loadingFn = async (status) => {

    dispatch(telemetryActions.setLoadingGraphAttribute(status));
    setLoading(status);

  };

  const apiRangeDate = () => {

    let start_date = '';
    let end_date = '';

    if (defaultGranularity === 'minute') {

      start_date = moment(moment(datePicker).format('YYYY-MM-DD 05:00:00')).format('YYYY-MM-DD HH:mm:ss');
      end_date = moment(moment(datePicker).format('YYYY-MM-DD 04:59:59')).add(1, 'days').format('YYYY-MM-DD HH:mm:ss');

    } else if (defaultGranularity === 'hour') {

      start_date = moment(moment(datePicker).format('YYYY-MM-DD 05:00:00')).format('YYYY-MM-DD HH:mm:ss');
      end_date = moment(moment(datePicker).format('YYYY-MM-DD 04:59:59')).add(1, 'days').format('YYYY-MM-DD HH:mm:ss');

    } else if (defaultGranularity === 'day' || defaultGranularity === 'month') {

      start_date = moment(moment(datePicker).format('YYYY-MM-01 05:00:00')).format('YYYY-MM-DD HH:mm:ss');
      end_date = moment(moment(datePicker).format('YYYY-MM-01 04:59:59')).add(31, 'days').format('YYYY-MM-DD HH:mm:ss');

    } else if (defaultGranularity === 'year') {

      start_date = moment(moment(datePicker).format('YYYY-01-01 05:00:00')).format('YYYY-MM-DD HH:mm:ss');
      end_date = moment(moment(datePicker).format('YYYY-12-31 04:59:59')).add(1, 'days').format('YYYY-MM-DD HH:mm:ss');

    }

    return {
      start_date,
      end_date,
    };

  };

  const consultaApi = async () => {

    setDeviceField(null);
    setOptionVariableField([]);
    setVariableField([]);

    const abortC = new AbortController();
    const { signal } = abortC;
    // console.log('useConsultGraph :: infoDevi', infoDevice);

    await devicesApi.getDeviceId({ signal, id: infoDevice }).then((data) => {

      // console.log('useConsultGraph :: data', data);
      // console.log('useConsultGraph name :: data', data.name);

      setDeviceAllInfo(data);
      setInfoDevice(data.name);

      // console.log('useConsultGraph :: device_types', data.device_types);
      setDeviceType(data.device_types);

      if (data.device_types.length > 0) {

        // console.log('defaultDeviceType ', data.device_types[0].id);
        setDeviceField(data.device_types[0].id);

      } else {

        setDeviceField(null);
        setOptionVariableField([]);
        setVariableField([]);
        loadingFn(false);

      }

    }).catch((error) => {

      console.log('getDeviceId :: error', error.data);

    });

  };

  const consultaApiField = async () => {

    setOptionVariableField([]);
    setVariableField([]);
    loadingFn(true);

    const abortC = new AbortController();
    const { signal } = abortC;

    const data = await telemetryApi.getAllDeviceField({ signal, device_type: deviceField });
    // console.log('consultaApiField :: data', data);

    if (data.length > 0 && deviceField != null) {

      // select variables Field
      const arrSelectVariablesField = data.map((item) => ({
        label: `${item.name} [${item.edge_name}]`,
        value: item.edge_name,
      }));
      setOptionVariableField(arrSelectVariablesField);

      let variablesValid = [];
      if (variableField.length > 0) {

        variablesValid = [...variableField];

      } else {

        variablesValid = [arrSelectVariablesField[0].value];

      }

      setVariableField(variablesValid);

    } else {

      setOptionVariableField([]);
      setVariableField([]);

    }

    loadingFn(false);

  };

  const consultaApiVariableField = async () => {

    // console.log('cambios ', variableField);
    const abortC = new AbortController();
    const { signal } = abortC;

    const auxArryVariable = [];

    optionVariableField.forEach((itemOptionVariable) => {

      variableField.forEach((itemVariableField) => {

        if (itemVariableField === itemOptionVariable.value) {

          auxArryVariable.push(itemOptionVariable);

        }

      });

    });

    // console.log('111111111 variableField ', variableField);

    let edge_name = variableField.join('&field=');
    edge_name = `&field=${edge_name}`;
    const rangeDate = apiRangeDate();

    if (!variableField || !variableField.length) {

      setSeriesGraph([]);
      setCategoriesGraph([]);
      return false;

    }

    const obj = {
      signal,
      device_type: deviceField,
      edge_name,
      device: infoDevice,
      start_date: rangeDate.start_date,
      end_date: rangeDate.end_date,
      granularity: defaultGranularity,
    };

    await telemetryApi.getGranularityData(obj).then((graphData) => {

      // console.log('consultaApiField :: data', graphData);

      const series = auxArryVariable.map((item, index) => {

        const dataSerieLabel = [];

        graphData.forEach((itemGraphData) => {

          const datgraph = itemGraphData;
          Object.keys(datgraph).forEach((indice) => {

            if (indice.toLowerCase() === item.value.toLowerCase()) {

              dataSerieLabel.push(datgraph[indice].toFixed(3));

            }

          });

        });

        const dataSeries = {
          name: item.label,
          type: 'area',
          data: dataSerieLabel,
        };

        return dataSeries;

      });

      const categories = graphData.map((item) => item).map((objArry) => `${objArry.date}.000Z`);

      // console.log('consultaApiField :: series', series);
      // console.log('consultaApiField :: categories', categories);

      setSeriesGraph(series);
      setCategoriesGraph(categories);

    }).catch((error) => {

      console.log('consultaApiField: error', error.data);
      setSeriesGraph([]);
      setCategoriesGraph([]);

    });

    return false;

  };

  const optionsGraph = {
    chart: {
      height: 600,
      type: 'area',
      stacked: false,
    },
    xaxis: {
      type: 'datetime',
      categories: categoriesGraph,
    },
    tooltip: {
      enabled: true,
      enabledOnSeries: [0, 1, 2, 3, 4, 5, 6, 7],
      shared: true,
      intersect: false,
      fixed: {
        enabled: false,
        position: 'topLeft',
        offsetY: -70,
      },
      followCursor: true,
      fillSeriesColor: false,
      theme: 'dark',
      style: {
        fontSize: '12px',
        fontFamily: undefined,
      },
      onDatasetHover: {
        highlightDataSeries: false,
      },
      items: {
        display: 'flex',
      },
      marker: {
        show: true,
      },
      x: {
        format: 'dd/MM/yy HH:mm',
      },
    },
  };

  useEffect(() => {

    setDeviceField(null);
    setOptionVariableField([]);
    setVariableField([]);

    if (device !== '') {

      setInfoDevice(device);

    } else {

      setDeviceAllInfo({});
      setDeviceType({});
      setOptionVariableField([]);
      setVariableField([]);

    }

  }, [device]);

  useEffect(() => {

    if (infoDevice !== null) {

      consultaApi();

    }

  }, [infoDevice]);

  useEffect(() => {

    if (infoDevice !== null && deviceField !== null && defaultGranularity !== null) {

      consultaApiField();

    }

  }, [deviceField, defaultGranularity, datePicker]);

  useEffect(() => {

    if (variableField !== null) {

      consultaApiVariableField();

    }

  }, [variableField]);

  return {
    loading,
    deviceType,
    deviceField,
    granularity,
    defaultGranularity,
    datePicker,
    modePicker,
    modePickerFormat,
    changeDate,
    setDatePicker,
    setDeviceField,
    setDefaultGranularity,
    categoriesGraph,
    optionsGraph,
    seriesGraph,
    variableField,
    setVariableField,
    optionVariableField,
    deviceAllInfo,
    setModePicker,
    setModePickerFormat,
  };

}

export default useConsultGraph;
